export function resolveTargetPath(path: string, previewRole: string | null): string {
  if (previewRole && path === "/api/integrations/production/mikro/production-plan/weekly-draft") {
    return "/api/demo/integrations/production/mikro/production-plan/weekly-draft";
  }
  if (
    path.startsWith("/api/integrations/production/mikro/") ||
    path.startsWith("/api/material-preparation/") ||
    path.startsWith("/api/sarf39/")
    || path.startsWith("/api/account-finance/")
    || path.startsWith("/api/shift-production-form/")
  ) return path;

  return previewRole && path.startsWith("/api/")
    ? `/api/demo${path.slice(4)}`
    : path;
}
